import axiosInstance from "../axiosInstance";

const CONTROLLER = "agents";

const get_agent_clients_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetPage?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const get_agent_clients_header_info = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentClientsHeader?search=${search || ""}`,
	);
	return response.data;
};

const get_agent_route_page = async (
	search,
	clientId,
	poolFilter,
	state,
	page,
	pageSize,
) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetAgentRoutesPage`, {
		params: {
			search: search,
			clientId: clientId,
			poolFilter: poolFilter,
			state: state,
			page: page,
			pageSize: pageSize,
		},
	});
	return response.data;
};

const find_pos_candidates = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/FindPosCandidates`, {
		params: { agentRouteId: id },
	});
	return response.data;
};

const confirm_validation = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/ConfirmValidation`,
		payload,
	);
	return response.data;
};

const update_agent_route_state = async (state) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentRouteState`,
		state,
	);
	return response.data;
};

const add_agent_routes = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/UpdateAgentRoutes`,
		payload,
	);
	return response.data;
};

const remove_agent_routes = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/RemoveAgentRoutes`,
		payload,
	);
	return response.data;
};

const create_pos_from_route = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/CreatePosFromAgentRoute`,
		payload,
	);
	return response.data;
};

const add_agent_route_by_cuit = async (data) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/AddAgentRouteByCuits`,
		data,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);
	return response.data;
};

const get_agent_pos_with_last_conv = async ({
	clientId,
	poolFilter,
	search,
	state,
	phase,
	sortLastConversation,
	page,
	actualPage,
}) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetAgentRouteConversations`,
		{
			params: {
				clientId,
				poolFilter,
				search,
				state,
				phase,
				sortLastConversation,
				page,
				actualPage,
			},
		},
	);
	return data;
};

const get_pos_conversations_page = async ({
	clientId,
	pointOfSaleId,
	page,
	actualPage,
}) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetAgentPosConversations`,
		{
			params: { clientId, pointOfSaleId, page, actualPage },
		},
	);
	return data;
};

const get_conversation_messages_page = async ({
	conversationId,
	page,
	actualPage,
}) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetAgentConversationMessages`,
		{
			params: { conversationId, page, actualPage },
		},
	);
	return data;
};

const agent_routes_to_validate = async (data) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/ValidateAgentRoutesByCuit`,
		data,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);
	return response.data;
};

const export_agent_routes_to_validate = async (clientId) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/ExportAgentRoutesToValidate?clientId=${clientId || ""}`,
		{
			responseType: "blob",
		},
	);
	return response.data;
};

const get_conversation_phases = async (clientId) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/GetConversationPhases?clientId=${clientId || ""}`,
	);
	return data;
};

const get_agent_config_by_id = async (clientId) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetAgentConfigById`, {
		params: {
			clientId: clientId,
		},
	});
	return response.data;
};

const create_agent_config = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/CreateAgentConfig`,
		payload,
	);
	return response.data;
};

const update_agent_config = async (id, payload) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentConfig/${id}`,
		payload,
	);
	return response.data;
};

const get_agent_configs_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetConfigPageOT?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const send_template_to_pos = async (payload) => {
	const res = await axiosInstance.post(
		`${CONTROLLER}/SendAgentTemplate`,
		payload,
	);
	return res.data;
};

const update_agent_orders = async (payload) => {
	const response = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgentOrderState`,
		payload,
	);
	return response.data;
};

const get_agent_conversation_by_id = async (conversationId) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentConversationById`,
		{
			params: {
				conversationId: conversationId,
			},
		},
	);
	return response.data;
};

const get_agent_orders_page = async (search, state, page, size) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentOrderPageOT?search=${
			search || ""
		}&state=${state}&pageNumber=${page}&pageSize=${size}`,
	);
	return response.data;
};

const get_agent_orders_header_info = async (search) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentOrdersHeaderOT?search=${search || ""}`,
	);
	return response.data;
};

const get_total_agent_order = async (laboratoryId) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetTotalPendingOrderOT?laboratoryId=${laboratoryId || ""}`,
	);
	return response.data;
};

const export_agent_pdv = async () => {
	const response = await axiosInstance.get(`${CONTROLLER}/ExportAgentPdvOT`, {
		responseType: "blob",
	});
	return response.data;
};

const get_agents_panel_page = async (search, state, page) => {
	const response = await axiosInstance.get(
		`${CONTROLLER}/GetAgentPanel?search=${
			search || ""
		}&state=${state}&pageNumber=${page}`,
	);
	return response.data;
};

const create_agent = async (payload) => {
	const response = await axiosInstance.post(
		`${CONTROLLER}/CreateAgent`,
		payload,
	);
	return response.data;
};

const get_agent_by_id = async (id) => {
	const response = await axiosInstance.get(`${CONTROLLER}/GetAgentById`, {
		params: {
			id: id,
		},
	});
	return response.data;
};

const update_agent = async (id, payload) => {
	const res = await axiosInstance.put(
		`${CONTROLLER}/UpdateAgent/${id}`,
		payload,
	);
	return res.data;
};

const get_agent_pos_selection_ids = async (params) => {
	const res = await axiosInstance.get(`${CONTROLLER}/GetSelectionIds`, {
		params,
	});
	return res.data;
};

const validate_whatsapps_list = async (clientId) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/ValidateWhatsappByClientId`,
		{ clientId },
	);
	return data;
};

const validate_whatsapp_single = async ({ userId, whatsappUserId }) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/ValidateWhatsappByUserId`,
		{
			userId: userId || null,
			whatsappUserId: whatsappUserId || null,
		},
	);
	return data;
};

const get_client_templates = async (clientId) => {
	const { data } = await axiosInstance.get(
		`${CONTROLLER}/ClientTemplates?clientId=${clientId}`,
	);
	return data;
};

const sync_client_templates = async (clientId) => {
	const { data } = await axiosInstance.post(`${CONTROLLER}/SyncMetaTemplates`, {
		clientId,
	});
	return data;
};

const set_client_templates = async (payload) => {
	const { data } = await axiosInstance.post(
		`${CONTROLLER}/AssignTemplates`,
		payload,
	);
	return data;
};

const get_templates_catalog = async (params) => {
	const qs = new URLSearchParams(params).toString();
	const { data } = await axiosInstance.get(`${CONTROLLER}/GetCatalog?${qs}`);
	return data;
};

export {
	get_agent_clients_page,
	get_agent_route_page,
	get_agent_clients_header_info,
	find_pos_candidates,
	confirm_validation,
	update_agent_route_state,
	add_agent_routes,
	remove_agent_routes,
	create_pos_from_route,
	add_agent_route_by_cuit,
	agent_routes_to_validate,
	export_agent_routes_to_validate,
	get_agent_pos_with_last_conv,
	get_conversation_messages_page,
	get_pos_conversations_page,
	get_conversation_phases,
	get_agent_config_by_id,
	create_agent_config,
	update_agent_config,
	get_agent_configs_page,
	send_template_to_pos,
	update_agent_orders,
	get_agent_conversation_by_id,
	get_agent_orders_page,
	get_agent_orders_header_info,
	get_total_agent_order,
	export_agent_pdv,
	get_agents_panel_page,
	create_agent,
	get_agent_by_id,
	update_agent,
	get_agent_pos_selection_ids,
	validate_whatsapp_single,
	validate_whatsapps_list,
	get_client_templates,
	sync_client_templates,
	set_client_templates,
	get_templates_catalog,
};
